var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.637695,
    y: 0.470215,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#9747FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6377 8.81396C13.6377 9.25146 13.6377 9.68896 13.6377 10.1265C14.4502 10.1265 15.4814 10.1265 16.2939 10.1265C16.2939 9.68896 16.2939 9.25146 16.2939 8.81396C15.4814 8.81396 14.4502 8.81396 13.6377 8.81396ZM12.2939 13.2202C12.9502 13.689 13.7627 14.314 14.4502 14.814C14.7002 14.439 14.9814 14.0952 15.2314 13.7515C14.5752 13.2515 13.7314 12.6265 13.1064 12.1265C12.8252 12.5015 12.5752 12.8452 12.2939 13.2202ZM15.2314 5.18896C14.9814 4.84521 14.7002 4.50146 14.4502 4.12646C13.7627 4.62646 12.9502 5.25146 12.2939 5.75146C12.5752 6.09521 12.8252 6.43896 13.1064 6.81396C13.7314 6.31396 14.5752 5.68896 15.2314 5.18896ZM4.29395 7.47021C3.5752 7.47021 2.98145 8.06396 2.98145 8.81396L2.98145 10.1265C2.98145 10.8765 3.5752 11.4702 4.29395 11.4702L4.98145 11.4702L4.98145 14.1265L6.29395 14.1265L6.29395 11.4702L6.98145 11.4702L10.2939 13.4702L10.2939 5.47021L6.98145 7.47021L4.29395 7.47021ZM7.66895 8.59521L8.98145 7.81396L8.98145 11.1265L7.66895 10.3452L7.3252 10.1265L4.29395 10.1265L4.29395 8.81396L7.3252 8.81396L7.66895 8.59521ZM11.9814 9.47021C11.9814 8.59521 11.5752 7.78271 10.9814 7.25146L10.9814 11.689C11.5752 11.1577 11.9814 10.3452 11.9814 9.47021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueIcon);
export default __webpack_public_path__ + "static/media/issue_icon.77dde3f4ab5434b25d7c99dfc14a0852.svg";
export { ForwardRef as ReactComponent };